module.exports = __webpack_public_path__ + "static/media/check_box.abd6985e.svg";